import React from 'react';

import {useRunSetsQuery} from '../../../state/runs/hooks';
import Export from '../../Export/Export';
import {usePanelsSharedRefsContext} from '../../Views/contexts/PanelsSharedRefsContext';
import {usePanelWithInheritedSettings} from '../../WorkspaceDrawer/Settings/hooks/usePanelInheritedSettings';
import {usePanelContext} from '../PanelContextProvider';

interface PanelExportCSVProps {
  trigger?: JSX.Element;
  open?: boolean;
  onClose?(): void;
}

export const PanelExportCSV = ({
  trigger,
  open,
  onClose,
}: PanelExportCSVProps) => {
  const {runSetRefs, customRunNamesRef} = usePanelsSharedRefsContext();
  const {panelRef, inheritedSettings} = usePanelContext();
  const pageQuery = useRunSetsQuery({runSetRefs, customRunNamesRef});
  const panel = usePanelWithInheritedSettings(panelRef, inheritedSettings);

  return (
    <Export
      panel={panel}
      pageQuery={pageQuery}
      trigger={trigger}
      open={open}
      onClose={onClose}
    />
  );
};
